<template>
    <a :href="url" class="h-full col-span-6 group p-0 md:col-span-2">
        <div class="flex flex-col-reverse justify-end h-full shadow-featured">
            <div class="p-8 lg:p-12">
                <div class="pb-3 md:pb-4">
                    <span v-if="hasIndustries">
                        <span class="mb-6 uppercase text-[14px] font-light text-black-soft" v-for="ind in resource.industries" v-text="ind"></span>
                    </span>
                    <span v-if="hasCategories">
                        <span class="mb-6 uppercase text-[14px] font-light text-black-soft" v-for="cat in resource.categories" v-text="cat"></span>
                    </span>
                </div>
                <p class="mb-4 animated group-hover:text-blue-flywire text-h3" v-text="title"></p>
            </div>
            <div class="aspect-3/2 w-full relative">
                <img v-if="hasImage" class="absolute w-full h-full object-cover" :src="resource.image" loading="lazy">
                <img v-else class="absolute w-full h-full object-cover" src="/media/img/flywire-resources-listing-placeholder.jpg" loading="lazy">
            </div>
        </div>
    </a>
</template>
<script>
    export default {
        props: ['resource'],
        computed: {
            hasCategories() {
                return (this.resource.categories.length > 0);
            },
            hasImage() {
                return (this.resource.image.length > 0);
            },
            hasIndustries() {
                return (this.resource.industries.length > 0);
            },
            title() {
                if (this.resource.type == 'resourceLink') {
                    return this.resource.linkUrl.one.title
                }

                return this.resource.title;

            },
            url() {
                if (this.resource.type == 'resourceLink') {
                    return this.resource.linkUrl.one.url
                }

                return this.resource.url;
            },
        },
    }
</script>
